export const Language = {
    FR: "fr",
    EN: "en",
    ZH: "zh",
    AR: "ar",
}